import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard, A11y } from 'swiper';
import useMediaQuery from '../custom-hooks/useMediaQuery';
import { withWidgetSpacingWrapper } from '../shared/WidgetSpacingWrapper';
import WidgetIdWrapper from '../shared/WidgetIdWrapper';
import { device } from '../../utils/styled-component-mixins';
import 'swiper/css';
import 'swiper/css/pagination';
import CardSwiperWrapperStyled from './styled-components/CardSwiperWrapperStyled';
import TransactionCard from './cards/TransactionCard';

const TransactionCarouselWrapperStyled = styled.div`
  .container-padding-md {
    background-color: var(--white);
    padding-left: 0;
  }

  .heading-wrapper {
    margin-bottom: 4rem;

    @media ${device.desktop} {
      margin-bottom: 3rem;
    }

    h2 {
      font-size: 3rem;
      font-weight: normal;
      line-height: 3.2rem;
      padding: 0 1.5rem;
      position: relative;
      text-align: center;
      z-index: 1;

      @media ${device.desktop} {
        font-size: 3.6rem;
        line-height: 4.8rem;
      }
    }
  }

  .link-container {
    padding: 0;

    > div {
      .btn-wrapper {
        @media ${device.desktop} {
          right: 11rem;
        }
      }
    }
  }

  .transaction-item-container {
    background-color: white;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: 100%;
    justify-content: center;
    position: relative;
    padding: 2rem 2rem;
    width: 100%;
  }

  .swiper-wrapper {
    @media ${device.desktop} {
      margin-left: -3rem;
    }
  }
`;

const TransactionCarouselComponent = (props) => {
  const transactions = props.items;
  const { transactionPageUrl, headerText, ctaText } = props;
  const isDesktop = useMediaQuery(device.desktop);

  return (
    <WidgetIdWrapper widgetID={props.widgetId}>
      <TransactionCarouselWrapperStyled>
        <div className="heading-wrapper">
          <h2>{headerText}</h2>
        </div>
        <CardSwiperWrapperStyled>
          <div className="container-padding-md">
            <div className="card-slider">
              <Swiper
                pagination={{ clickable: { isDesktop } }}
                spaceBetween={16}
                modules={[Pagination, Navigation, Keyboard, A11y]}
                a11y={true}
                navigation={true}
                keyboard={true}
                breakpoints={{
                  320: {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    slidesPerGroup: 1
                  },
                  992: {
                    centeredSlides: false,
                    slidesPerView: 'auto',
                    slidesPerGroup: 4,
                    slidesOffsetBefore: 64
                  }
                }}
              >
                {transactions.length > 0 &&
                  transactions.map((item) => (
                    <SwiperSlide key={item.pageTitle}>
                      <div className="transaction-item-container">
                        <TransactionCard transaction={item} />
                      </div>
                    </SwiperSlide>
                  ))}
              </Swiper>
              {ctaText && transactionPageUrl && (
                <div className="link-container">
                  <ButtonLink
                    text={ctaText}
                    link={transactionPageUrl}
                    target="_self"
                    type="tertiary"
                    theme="light"
                  />
                </div>
              )}
            </div>
          </div>
        </CardSwiperWrapperStyled>
      </TransactionCarouselWrapperStyled>
    </WidgetIdWrapper>
  );
};

export default withWidgetSpacingWrapper(TransactionCarouselComponent);
